import queryString from "query-string";
import { useEffect, useState } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { parseQueryString, validNumber } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

const CementscreedCalculator = () => {
    const q = queryString.parse(location.search, {
        parseNumbers: true
    });

    const [cementscreedLength, setCementscreedLength] = useState<number>(
        parseQueryString(q.cementscreedLength)
    );

    const [cementscreedWidth, setCementscreedWidth] = useState<number>(
        parseQueryString(q.cementscreedWidth)
    );

    const [cementscreedThickness, setCementscreedThickness] = useState<number>(
        parseQueryString(q.cementscreedThickness)
    );

    const [cementscreedArea, setCementscreedArea] = useState(0);
    const [cementscreedVolume, setCementscreedVolume] = useState(0);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementscreedArea(determineCementscreedArea());
        setCementscreedVolume(determineCementscreedVolume());
        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.cementScreed);
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        setCementscreedArea(determineCementscreedArea());
        setCementscreedVolume(determineCementscreedVolume());
    }, [cementscreedLength, cementscreedWidth, cementscreedThickness]);

    const determineCementscreedArea = () => {
        const length = cementscreedLength;

        const width = cementscreedWidth;
        const area = Number(length * width);

        return validNumber(area) ? area : 0;
    };

    const determineCementscreedVolume = () => {
        const length = cementscreedLength;

        const width = cementscreedWidth;

        const height = cementscreedThickness * 0.01; // convert cm to m
        const volume = Number(length * width * height);

        return validNumber(volume) ? volume : 0;
    };

    const setCalculationValue = (field: string, value: string) => {
        const numberValue = parseFloat(value.replace(",", "."));
        switch (field) {
            case "cementscreedLength": {
                setCementscreedLength(numberValue);
                break;
            }
            case "cementscreedWidth": {
                setCementscreedWidth(numberValue);
                break;
            }
            case "cementscreedThickness": {
                setCementscreedThickness(numberValue);
                break;
            }
        }

        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.cementScreed);
    };

    const calculationProps = {
        setCalculationValue: setCalculationValue,
        cementscreedLength: cementscreedLength,
        cementscreedWidth: cementscreedWidth,
        cementscreedThickness: cementscreedThickness
    };
    const resultProps = {
        cementscreedArea: cementscreedArea,
        cementscreedVolume: cementscreedVolume,
        mailParams: {
            cementscreedLength: cementscreedLength,
            cementscreedWidth: cementscreedWidth,
            cementscreedThickness: cementscreedThickness
        }
    };

    return (
        <div id="calculator">
            <Calculation {...calculationProps} />
            <Result {...resultProps} />
        </div>
    );
};

export { CementscreedCalculator };
